import { RootState } from "../../reducers"

export const selectMobileReservations = (state: RootState) =>
	state.mobile.reservations
